module.exports = __webpack_public_path__ + "static/media/日历10@2x.5bad2c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历10@2x.png
// module id = 1384
// module chunks = 0